import styled from 'styled-components';
import { Heading, Div, Flex } from '@certilogo/design-system-web';
import { secondaryColor } from '@certilogo/design-system-web/dist/shared/styles/themes/selectors';
import { padding } from '@certilogo/design-system-web/dist/shared/styles';

export const Wrapper = styled(Div)`
  position: relative;
`;

export const Title = styled(Heading).attrs({
  type: 'h1',
  marginBottom: 'l',
})``;

export const Card = styled(Flex)`
  flex-direction: column;
  background-color: ${secondaryColor};
  border-radius: 6px;
  margin-left: -10px;
  margin-right: -10px;
  ${padding('m')}
`;
